/**
 * @generated SignedSource<<e7930a12672e9950ad2cb38aec9ac78a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TypeDefinitionType = "branch" | "content" | "%future added value";
export type AnswersScreen_Query$variables = {
  learnOpportunityId: string;
};
export type AnswersScreen_Query$data = {
  readonly node: {
    readonly typeDefinition?: {
      readonly definitionType: TypeDefinitionType;
      readonly showAnswerElements?: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"ElementAnswers_ElementFragment">;
      }> | null;
    };
    readonly " $fragmentSpreads": FragmentRefs<"NodeContainer_LearnOpportunityV2Fragment">;
  } | null;
};
export type AnswersScreen_Query = {
  response: AnswersScreen_Query$data;
  variables: AnswersScreen_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "learnOpportunityId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "learnOpportunityId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "definitionType",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v8 = [
  (v7/*: any*/),
  (v4/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "file",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v11 = [
  (v10/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cmePoints",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "containedElementTypes",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortDescription",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstLearnOpportunityIdWithMultipleChoiceElement",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "extension",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v12/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headFirstElementType",
          "storageKey": null
        }
      ],
      "type": "LearnContentExtensionImpl",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v19 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "reasonConfigTypes",
    "storageKey": null
  }
],
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "LearnOpportunityV2",
  "kind": "LinkedField",
  "name": "root",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "structureDefinition",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v6/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "viewerTreeState",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "kind",
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v19/*: any*/),
                  "type": "CanNotBeStartedViewerTreeState",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "headContentId",
                      "storageKey": null
                    }
                  ],
                  "type": "IsStartedViewerTreeState",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "LearnOpportunityRootStructureDefinition",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AnswersScreen_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "typeDefinition",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "showAnswerElements",
                        "plural": true,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ElementAnswers_ElementFragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "LearnOpportunityELearningContentTypeDefinition",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NodeContainer_LearnOpportunityV2Fragment"
              }
            ],
            "type": "LearnOpportunityV2",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AnswersScreen_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "typeDefinition",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "showAnswerElements",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isElementV2"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "elementType",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/)
                            ],
                            "type": "TextElementV2",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "question",
                                "storageKey": null
                              },
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "answeringType",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AnswerOptionV2",
                                "kind": "LinkedField",
                                "name": "answerOptions",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "answer",
                                    "storageKey": null
                                  },
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isCorrect",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "MultipleChoiceElementV2",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "podcastSource",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sourceType",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "podigeeUrl",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "PodigeePodcastSourceV2",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ReleasedFileV2",
                                "kind": "LinkedField",
                                "name": "releasedFileOpt",
                                "plural": false,
                                "selections": (v11/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ReleasedSubtitlesV2",
                                "kind": "LinkedField",
                                "name": "releasedSubtitlesOpt",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SubtitlesV2",
                                    "kind": "LinkedField",
                                    "name": "subtitles",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SubtitleV2",
                                        "kind": "LinkedField",
                                        "name": "subtitles",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "startTime",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "endTime",
                                            "storageKey": null
                                          },
                                          (v5/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v6/*: any*/)
                            ],
                            "type": "PodcastElementV2",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v6/*: any*/)
                            ],
                            "type": "VideoElement",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fileContentType",
                                "storageKey": null
                              },
                              (v6/*: any*/)
                            ],
                            "type": "FileElementV2",
                            "abstractKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "extension",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lengthInSecondsOverride",
                                "storageKey": null
                              },
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "amountOfMultipleChoiceElementsInContentSubmission",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentConfigConsequences",
                                "kind": "LinkedField",
                                "name": "configConsequences",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "percentageRequiredToPass",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isBlockedPermanentlyAfterNumFailedTries",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isBlockedTemporarilyForNumDaysAfterOneFailedTry",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "LearnContentExtensionImpl",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v13/*: any*/)
                    ],
                    "type": "LearnOpportunityELearningContentTypeDefinition",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LearnOpportunityV2",
                "kind": "LinkedField",
                "name": "root",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "structureDefinition",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "File",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Tag",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              (v15/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "colorHex",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "extension",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "InfectopharmTreeConfigConsequences",
                                    "kind": "LinkedField",
                                    "name": "configConsequences",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "restartTriesCount",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isRewardedTo",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "rewardExpired",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "showAnswerExpired",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v16/*: any*/)
                                ],
                                "type": "LearnOpportunityRootExtensionImpl",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "LearnOpportunityRootStructureDefinition",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "typeDefinition",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "contentNodeAdvancementResult",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v17/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          (v18/*: any*/)
                        ],
                        "type": "LearnOpportunityELearningContentTypeDefinition",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LearnOpportunityV2",
                            "kind": "LinkedField",
                            "name": "children",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "typeDefinition",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "contentNodeAdvancementResult",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v17/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v19/*: any*/),
                                            "type": "CanNotBeStartedContentNodeAdvancementResult",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "activeContentSubmissionId",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "ContinueContentNodeAdvancementResult",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "configResults",
                                                "plural": true,
                                                "selections": [
                                                  (v3/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "configType",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isRestartIfFailedContentConfigResult"
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "canBeRestarted",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "blockedUntil",
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "type": "NegativeBlockTemporarilyRestartIfFailedContentConfigResult",
                                                    "abstractKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "CanNotBeRestartedAfterFailedContentNodeAdvancementResult",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v13/*: any*/),
                                      (v18/*: any*/)
                                    ],
                                    "type": "LearnOpportunityELearningContentTypeDefinition",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v14/*: any*/),
                              (v20/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "structureDefinition",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "attachmentsV2",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v11/*: any*/),
                                    "type": "InfectopharmFileAttachment",
                                    "abstractKey": null
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "LearnOpportunityBranchTypeDefinition",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "attachmentsV2",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "File",
                            "kind": "LinkedField",
                            "name": "file",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v4/*: any*/),
                              (v15/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "InfectopharmFileAttachment",
                        "abstractKey": null
                      },
                      (v4/*: any*/),
                      (v6/*: any*/),
                      (v21/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "structureDefinition",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "extension",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/)
                            ],
                            "type": "LearnOpportunityRootExtensionImpl",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "LearnOpportunityRootStructureDefinition",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v21/*: any*/)
            ],
            "type": "LearnOpportunityV2",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "748b02b483f41f32974a2725d045ed0d",
    "id": null,
    "metadata": {},
    "name": "AnswersScreen_Query",
    "operationKind": "query",
    "text": "query AnswersScreen_Query(\n  $learnOpportunityId: ID!\n) {\n  node(id: $learnOpportunityId) {\n    __typename\n    ... on LearnOpportunityV2 {\n      typeDefinition {\n        __typename\n        definitionType\n        ... on LearnOpportunityELearningContentTypeDefinition {\n          showAnswerElements {\n            __typename\n            ...ElementAnswers_ElementFragment\n            id\n          }\n        }\n      }\n      ...NodeContainer_LearnOpportunityV2Fragment\n    }\n    id\n  }\n}\n\nfragment AttachmentButtonsDisplayFragment_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  root {\n    id\n    attachmentsV2 {\n      __typename\n      title\n      description\n      ... on InfectopharmFileAttachment {\n        file {\n          id\n          url\n          name\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment AttachmentHeftDisplay_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  id\n  structureDefinition {\n    __typename\n    ... on LearnOpportunityRootStructureDefinition {\n      extension {\n        __typename\n        ... on LearnOpportunityRootExtensionImpl {\n          firstLearnOpportunityIdWithMultipleChoiceElement\n        }\n      }\n    }\n  }\n  root {\n    id\n    structureDefinition {\n      __typename\n      ... on LearnOpportunityRootStructureDefinition {\n        extension {\n          __typename\n          ... on LearnOpportunityRootExtensionImpl {\n            firstLearnOpportunityIdWithMultipleChoiceElement\n          }\n        }\n      }\n    }\n    attachmentsV2 {\n      __typename\n      ... on InfectopharmFileAttachment {\n        file {\n          url\n          id\n        }\n      }\n      id\n    }\n    typeDefinition {\n      __typename\n      ... on LearnOpportunityBranchTypeDefinition {\n        children {\n          id\n          attachmentsV2 {\n            __typename\n            ... on InfectopharmFileAttachment {\n              file {\n                url\n                id\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n  ...AttachmentButtonsDisplayFragment_LearnOpportunityV2Fragment\n}\n\nfragment ElementAnswers_ElementFragment on ElementV2 {\n  __isElementV2: __typename\n  elementType\n  ...TextElementDisplayWithAnswers_TextElementV2Fragment\n  ...MultipleChoiceElementDisplayWithAnswers_MultipleChoiceElementV2Fragment\n  ...PodcastElementDisplayWithAnswers_PodcastElementV2Fragment\n  ...VideoElementDisplayWithAnswers_VideoElementV2Fragment\n  ...FileElementDisplayWithAnswers_FileElementV2Fragment\n  ... on MultipleChoiceElementV2 {\n    answerOptions {\n      isCorrect\n    }\n  }\n}\n\nfragment FileElementDisplayWithAnswers_FileElementV2Fragment on FileElementV2 {\n  file {\n    url\n    id\n  }\n  fileContentType\n  title\n}\n\nfragment MultipleChoiceElementDisplayWithAnswers_MultipleChoiceElementV2Fragment on MultipleChoiceElementV2 {\n  question\n  image {\n    url\n    id\n  }\n  answeringType\n  answerOptions {\n    answer\n    image {\n      url\n      id\n    }\n  }\n}\n\nfragment NavigateDirectToQuestionsAdvanceTreeButton_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  id\n  shortDescription\n  root {\n    id\n    structureDefinition {\n      __typename\n      title\n      ... on LearnOpportunityRootStructureDefinition {\n        viewerTreeState {\n          __typename\n          kind\n          ... on CanNotBeStartedViewerTreeState {\n            reasonConfigTypes\n          }\n          ... on IsStartedViewerTreeState {\n            headContentId\n          }\n        }\n      }\n    }\n  }\n  structureDefinition {\n    __typename\n    title\n  }\n  typeDefinition {\n    __typename\n    definitionType\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      contentNodeAdvancementResult {\n        __typename\n        status\n      }\n      containedElementTypes\n      extension {\n        __typename\n        ... on LearnContentExtensionImpl {\n          cmePoints\n          headFirstElementType\n        }\n      }\n    }\n  }\n}\n\nfragment NodeConfigurationsDisplay_NodeFragment on LearnOpportunityV2 {\n  root {\n    structureDefinition {\n      __typename\n      ... on LearnOpportunityRootStructureDefinition {\n        extension {\n          __typename\n          ... on LearnOpportunityRootExtensionImpl {\n            configConsequences {\n              rewardExpired\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n  typeDefinition {\n    __typename\n    definitionType\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      extension {\n        __typename\n        ... on LearnContentExtensionImpl {\n          amountOfMultipleChoiceElementsInContentSubmission\n          configConsequences {\n            percentageRequiredToPass\n            isBlockedPermanentlyAfterNumFailedTries\n            isBlockedTemporarilyForNumDaysAfterOneFailedTry\n          }\n        }\n      }\n      containedElementTypes\n    }\n  }\n}\n\nfragment NodeContainer_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  root {\n    ...NodeContentElementsList_NodeFragment\n    id\n    typeDefinition {\n      __typename\n      definitionType\n      ... on LearnOpportunityELearningContentTypeDefinition {\n        containedElementTypes\n      }\n      ... on LearnOpportunityBranchTypeDefinition {\n        children {\n          ...ProjectContentButtonCME_LearnOpportunityFragment\n          id\n          shortDescription\n          structureDefinition {\n            __typename\n            title\n          }\n          typeDefinition {\n            __typename\n            definitionType\n            ... on LearnOpportunityELearningContentTypeDefinition {\n              containedElementTypes\n              contentNodeAdvancementResult {\n                __typename\n                status\n                ... on CanNotBeStartedContentNodeAdvancementResult {\n                  reasonConfigTypes\n                }\n                ... on ContinueContentNodeAdvancementResult {\n                  activeContentSubmissionId\n                }\n                ... on CanNotBeRestartedAfterFailedContentNodeAdvancementResult {\n                  configResults {\n                    __typename\n                    configType\n                    __isRestartIfFailedContentConfigResult: __typename\n                    canBeRestarted\n                    ... on NegativeBlockPermanentlyRestartIfFailedContentConfigResult {\n                      canBeRestarted\n                    }\n                    ... on NegativeBlockTemporarilyRestartIfFailedContentConfigResult {\n                      blockedUntil\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    structureDefinition {\n      __typename\n      title\n      ... on LearnOpportunityRootStructureDefinition {\n        icon {\n          url\n          id\n        }\n        ...NodeTagList_LearnOpportunityRootStructureDefinitionFragment\n        extension {\n          __typename\n          ... on LearnOpportunityRootExtensionImpl {\n            configConsequences {\n              restartTriesCount\n              isRewardedTo\n              rewardExpired\n              showAnswerExpired\n            }\n          }\n        }\n      }\n    }\n  }\n  structureDefinition {\n    __typename\n    title\n  }\n  typeDefinition {\n    __typename\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      extension {\n        __typename\n        ... on LearnContentExtensionImpl {\n          lengthInSecondsOverride\n          cmePoints\n        }\n      }\n      containedElementTypes\n    }\n  }\n  ...ProjectNodeTopBar_LearnOpportunityV2Fragment\n  ...NodeConfigurationsDisplay_NodeFragment\n  ...NodeDescription_NodeFragment\n  ...AttachmentHeftDisplay_LearnOpportunityV2Fragment\n}\n\nfragment NodeContentElementsList_NodeFragment on LearnOpportunityV2 {\n  id\n  shortDescription\n  structureDefinition {\n    __typename\n    title\n  }\n  ...ProjectContentButtonCME_LearnOpportunityFragment\n  typeDefinition {\n    __typename\n    definitionType\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      containedElementTypes\n    }\n    ... on LearnOpportunityBranchTypeDefinition {\n      children {\n        ...ProjectContentButtonCME_LearnOpportunityFragment\n        id\n        shortDescription\n        structureDefinition {\n          __typename\n          title\n        }\n        typeDefinition {\n          __typename\n          definitionType\n          ... on LearnOpportunityELearningContentTypeDefinition {\n            containedElementTypes\n            contentNodeAdvancementResult {\n              __typename\n              status\n              ... on CanNotBeStartedContentNodeAdvancementResult {\n                reasonConfigTypes\n              }\n              ... on ContinueContentNodeAdvancementResult {\n                activeContentSubmissionId\n              }\n              ... on CanNotBeRestartedAfterFailedContentNodeAdvancementResult {\n                configResults {\n                  __typename\n                  configType\n                  __isRestartIfFailedContentConfigResult: __typename\n                  canBeRestarted\n                  ... on NegativeBlockPermanentlyRestartIfFailedContentConfigResult {\n                    canBeRestarted\n                  }\n                  ... on NegativeBlockTemporarilyRestartIfFailedContentConfigResult {\n                    blockedUntil\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment NodeDescription_NodeFragment on LearnOpportunityV2 {\n  description\n}\n\nfragment NodeTagList_LearnOpportunityRootStructureDefinitionFragment on LearnOpportunityRootStructureDefinition {\n  tags {\n    id\n    ...NodeTag_TagFragment\n  }\n}\n\nfragment NodeTag_TagFragment on Tag {\n  id\n  name\n  colorHex\n}\n\nfragment PodcastElementDisplayWithAnswers_PodcastElementV2Fragment on PodcastElementV2 {\n  podcastSource {\n    __typename\n    sourceType\n    ... on PodigeePodcastSourceV2 {\n      podigeeUrl\n    }\n  }\n  releasedFileOpt {\n    file {\n      url\n      id\n    }\n  }\n  releasedSubtitlesOpt {\n    subtitles {\n      subtitles {\n        startTime\n        endTime\n        text\n      }\n    }\n  }\n  title\n}\n\nfragment ProjectContentButtonCME_LearnOpportunityFragment on LearnOpportunityV2 {\n  id\n  typeDefinition {\n    __typename\n    definitionType\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      contentNodeAdvancementResult {\n        __typename\n        status\n      }\n    }\n  }\n  ...NavigateDirectToQuestionsAdvanceTreeButton_LearnOpportunityV2Fragment\n}\n\nfragment ProjectNodeTopBar_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  id\n  typeDefinition {\n    __typename\n    definitionType\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      containedElementTypes\n    }\n  }\n  root {\n    id\n  }\n}\n\nfragment TextElementDisplayWithAnswers_TextElementV2Fragment on TextElementV2 {\n  text\n  title\n}\n\nfragment VideoElementDisplayWithAnswers_VideoElementV2Fragment on VideoElement {\n  title\n}\n"
  }
};
})();

(node as any).hash = "0b9a2e68dffea71b98ebcb999d17a8a0";

export default node;
